import { useLiveQuery } from 'dexie-react-hooks'

import { getRemoteInspectionsByAsset } from 'services/inspections'

const useInspectionsByAsset = (assetId: string) => {
  return useLiveQuery(() => getRemoteInspectionsByAsset(assetId), [assetId], [])
}

export default useInspectionsByAsset
